{
  "version": 1,
  "asset_id": "96124d4f-73d0-4ad4-bb12-78a190e42740",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/96124d4f-73d0-4ad4-bb12-78a190e42740/svc-web-design-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/96124d4f-73d0-4ad4-bb12-78a190e42740/svc-web-design-1200.webp",
  "original_filename": "svc-web-design-1200.webp",
  "size": 8334,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:01Z"
}
